import { getObjectItemByPath, isoToBrDate } from '../utils';
import { fieldMappings } from '../contants';
import { formatNumber } from '../views/TicketSidebar';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('pt-BR', options);
}

export default function OrderInfo({
    order, 
    onSelect, 
    onShowDetails,
    onApplyData,
    vtexZendeskMap
}) {

    return (
        <nav>
        <div className='orderTicket'>
          <span>Pedido: {order.orderId}</span>
          <button className="icon-view" onClick={() => onShowDetails(order)}>
            <i id="#view" className="fas fa-eye"></i>
        </button>
        </div>

        <input 
            onClick={_ => onSelect(order)}
            className='my-checkbox-x2' 
            type="radio"
            name='check'
            id='touch' />
      
            <ul className='slide'>
                <li><p>Sequence: <strong>{order.sequence}</strong></p></li>
                <li><p>Descrição do Status: <strong>{order.statusDescription}</strong></p></li>
                <li><p>Data: <strong>{isoToBrDate(order.creationDate)}</strong></p></li>
                <hr></hr>
                <p className='title-vtex'>Campos vtex: </p>
                {
                    Object.entries(vtexZendeskMap).map(([key, _]) => ( <li>
                          <p>{fieldMappings[key] || key}:</p>
                          <p><strong>{key === 'shippingData.logisticsInfo.shippingEstimateDate' ? formatDate(getObjectItemByPath(order, key)) : formatNumber(getObjectItemByPath(order, key)) || 'Carregando'}</strong></p>
                    </li>)
                )}
                <button onClick={() => onApplyData(order)}>Aplicar dados</button>
            </ul>
        </nav>
    )
}